import "./styles.css";
import React, { useState } from "react";
import { Mug } from "react-kawaii";
import { useForm } from "react-hook-form";
import { FacebookShareButton, FacebookIcon } from "react-share";

export default function App() {
  const adviceAPI = "https://api.adviceslip.com/advice";
  const { register, handleSubmit } = useForm();
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [mood, setMood] = useState("happy");
  const [advice, setAdvice] = useState("Do not compare yourself with others.");

  const onSubmit = (data) => {
    setFirstName(
      JSON.stringify(data.firstName).replace(/['"]+/g, "").toUpperCase()
    );
    setLastName(
      JSON.stringify(data.lastName).replace(/['"]+/g, "").toUpperCase()
    );
    setMood(JSON.stringify(data.mood).replace(/['"]+/g, ""));
    getAdvice();
  };

  const getAdvice = () => {
    return fetch(adviceAPI)
      .then((response) => response.json())
      .then(({ slip }) => setAdvice(slip.advice));
  };

  return (
    <div className="container m-4 p-4 mx-auto h-min-screen grid grid-rows-1 grid-cols-1 items-center">
      <div className="wrapper">
        <h1 className="animate-ping text-center text-1xl font-bold">
          What is your mood today?
        </h1>

        <div className="animate-bounce m-4 mx-auto flex justify-center">
          <Mug size={100} mood={mood} color="#f582ae" />
        </div>

        <form
          className="m-2 mx-auto flex flex-col"
          onSubmit={handleSubmit(onSubmit)}
        >
          <input
            className="m-2 border-2 border-black h-10 px-2 rounded-lg text-center focus:outline-none focus:border-pink-400"
            {...register("firstName")}
            placeholder="First name"
          />
          <input
            className="m-2 border-2 border-black h-10 px-2 rounded-lg text-center focus:outline-none focus:border-pink-400"
            {...register("lastName")}
            placeholder="Last name"
          />
          <select
            className="m-2 border-2 border-black h-10 px-2 rounded-lg text-center focus:outline-none focus:border-pink-400"
            {...register("mood")}
          >
            <option value="">Select Your Mood</option>
            <option value="blissful">blissful</option>
            <option value="sad">sad</option>
            <option value="shocked">shocked</option>
            <option value="happy">happy</option>
            <option value="lovestruck">lovestruck</option>
            <option value="excited">excited</option>
          </select>

          <button className="m-2 mt-4 bg-gray-600 h-10 px-2 rounded-lg text-pink-400 font-bold">
            Submit
          </button>

          <p className="m-4 text-2xl text-center">
            Hello{" "}
            <span className="text-pink-500">{`${firstName} ${lastName}`}</span>,
            <br />
            You feel <span className="text-pink-500"> {mood}</span> today!
            <br />
            <span className="text-pink-500">{`"${advice}"`}</span>
          </p>
        </form>

        <div className="m-2 mx-auto flex justify-center">
          <FacebookShareButton url="https://eflzx.csb.app/">
            <FacebookIcon size={32} round={true} />
          </FacebookShareButton>
        </div>
      </div>
    </div>
  );
}
